export var dpDetailsMapper = function (data, accCode) {
    var result = [];
    if (data && data.length > 0) {
        console.log("DP Details Maapper  req", data);
        result = data
            .filter(function (records) { return records.acCode == accCode; })
            .map(function (item) {
            return {
                depository: item.depository,
                dpName: item.dP_Name,
                dpId: item.dP_ID,
                accountNo: item.account_No,
                poa: item.poa,
                dpStatus: item.dpstatus,
                dpDetails: item.dpstatus,
                backOfficeURL: item.back_Office_URL,
                acCode: item.acCode,
                acTypeFlag: item.actypeflag,
                queryString: item.queryString,
                isParamEncoded: item.isParamEncoded,
                ddpi: item.ddpi,
                defaultDP: item.defaultDP,
                nominationStatus: item.nominationStatus,
            };
        });
    }
    console.log("DP Details Maapper", result);
    return result;
};
